import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SupplierMenuContainer from '../containers/menus/SupplierMenuContainer';
import RetailerMenuContainer from '../containers/menus/RetailerMenuContainer';

const HeaderRoutes = () => {
  return (
    <Switch>
      {/* Display SupplierMenuContainer for all suppliers/:id routes */}
      <Route path="/suppliers/:supplierId" history={BrowserRouter} component={SupplierMenuContainer} />

      {/* Display RetailerMenuContainer for all retailers/:id routes */}
      <Route path="/retailers/:retailerId" history={BrowserRouter} component={RetailerMenuContainer} />

      <Route path="/user" history={BrowserRouter} component={RetailerMenuContainer} />
    </Switch>
  );
};

export default HeaderRoutes;
